import { actionTypePatient } from "../types";

const initialState = {
    loading: false,
    error: null,
    getAppointmentsData: [],
    getClinicUpcomingAppointmentsData: [],
    getRequestedAppointmentsData: [],
    getClinicRequestedAppointmentsData: [],
    postSearchDocAppoData: [],
    getUserTypeAppointmentData: [],
    postAllAvailabilityData: [],
    getSelectedUserDetailsData: [],
    postBookedAppointmentData: [],
    getQuestionData: [],
    getpatientByIdData: [],
    getBookedChatDetailsData: [],
    getFetchNextAppointnentsData: [],
    postGetEmergencyCallByPatientData: [],
    postGetChatAppointmentByPatientData: [],
};

const reducerPatient = (state = initialState, action) => {
    switch (action.type) {
        case actionTypePatient.GET_APPOINTMENTS_REQUEST:
            return {
                ...state,
                error: null,
                loading: true,
            };
        case actionTypePatient.GET_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                getAppointmentsData: action.payload,
                error: null,
                loading: false,

            };

        case actionTypePatient.GET_APPOINTMENTS_FAILURE:
            return {
                ...state,
                error: null,
                getAppointmentsData: [],
                loading: false,
            };

        case actionTypePatient.CLEAR_APPOINTMENTS_DATA:
            return {
                ...state,
                loading: true,
                getAppointmentsData: [],
            };
        case actionTypePatient.GET_CLINIC_UPCOMING_APPOINTMENTS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_CLINIC_UPCOMING_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                getClinicUpcomingAppointmentsData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_CLINIC_UPCOMING_APPOINTMENTS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_REQUESTED_APPOINTMENTS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_REQUESTED_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                getRequestedAppointmentsData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_REQUESTED_APPOINTMENTS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_CLINIC_REQUESTED_APPOINTMENTS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_CLINIC_REQUESTED_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                getClinicRequestedAppointmentsData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_CLINIC_REQUESTED_APPOINTMENTS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_SEARCH_DOCTOR_APPOINTMENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_SEARCH_DOCTOR_APPOINTMENT_SUCCESS:
            return {
                ...state,
                postSearchDocAppoData: action.payload,
                error: null,
            };

        case actionTypePatient.POST_SEARCH_DOCTOR_APPOINTMENT_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypePatient.GET_USER_TYPE_APPOINTMENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_USER_TYPE_APPOINTMENT_SUCCESS:
            return {
                ...state,
                getUserTypeAppointmentData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_USER_TYPE_APPOINTMENT_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_ALL_AVAILABILITY_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_ALL_AVAILABILITY_SUCCESS:
            return {
                ...state,
                postAllAvailabilityData: action.payload,
                error: null,
            };

        case actionTypePatient.POST_ALL_AVAILABILITY_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypePatient.GET_SELECTED_USER_DETAILS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_SELECTED_USER_DETAILS_SUCCESS:
            return {
                ...state,
                getSelectedUserDetailsData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_SELECTED_USER_DETAILS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_BOOKED_APPOINTMENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_BOOKED_APPOINTMENT_SUCCESS:
            return {
                ...state,
                postBookedAppointmentData: action.payload,
                error: null,
            };

        case actionTypePatient.POST_BOOKED_APPOINTMENT_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_QUESTION_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_QUESTION_SUCCESS:
            return {
                ...state,
                getQuestionData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_QUESTION_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_ANSWERS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_ANSWERS_SUCCESS:
            return {
                ...state,
                getAnswersData: action.payload,
                error: null,
            };

        case actionTypePatient.GET_ANSWERS_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypePatient.GET_PATIENT_BY_ID_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_PATIENT_BY_ID_SUCCESS:
            return {
                ...state,
                getpatientByIdData: action.payload,
                error: null,
            };
        case actionTypePatient.GET_PATIENT_BY_ID_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypePatient.GET_BOOKED_CHAT_DETAILS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.GET_BOOKED_CHAT_DETAILS_SUCCESS:
            return {
                ...state,
                getBookedChatDetailsData: action.payload,
                error: null,
            };
        case actionTypePatient.GET_BOOKED_CHAT_DETAILS_FAILURE:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_FETCH_NEXT_APPOINTMENTS_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_FETCH_NEXT_APPOINTMENTS_SUCCESS:
            return {
                ...state,
                getFetchNextAppointnentsData: action.payload,
                error: null,
            };
        case actionTypePatient.POST_FETCH_NEXT_APPOINTMENTS_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypePatient.POST_GET_EMERGENCY_CALL_BY_PATIENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_GET_EMERGENCY_CALL_BY_PATIENT_SUCCESS:
            return {
                ...state,
                postGetEmergencyCallByPatientData: action.payload,
                error: null,
            };
        case actionTypePatient.POST_GET_EMERGENCY_CALL_BY_PATIENT_FAILURE:
            return {
                ...state,
                error: null,
            };

        case actionTypePatient.POST_GET_CHAT_APPOINTMENT_BY_PATIENT_REQUEST:
            return {
                ...state,
                error: null,
            };
        case actionTypePatient.POST_GET_CHAT_APPOINTMENT_BY_PATIENT_SUCCESS:
            return {
                ...state,
                postGetChatAppointmentByPatientData: action.payload,
                error: null,
            };
        case actionTypePatient.POST_GET_CHAT_APPOINTMENT_BY_PATIENT_FAILURE:
            return {
                ...state,
                error: null,
            };

        default:
            return state;
    }
};

export default reducerPatient;
